module.exports = __webpack_public_path__ + "img/demo3-poster.0d52fe8d.jpg";